import { userIdQuery } from '../../authentication/queries';
import { createCommand } from '../../utils';
import { setColumnVisibility, moduleName } from '../state';

const LoadColumnsPreferenceCommand = createCommand(
    `${moduleName}/LOAD_COLUMNS_PREFERENCE`,
    async (_, { dispatch, extra, getState }) => {
        const userId = userIdQuery(getState());
        if (userId) {
            const saved = extra.externalSessionConfiguration.loadColumnVisibility(userId);
            dispatch(setColumnVisibility(saved));
        }
    },
);

export default LoadColumnsPreferenceCommand;
